import React, {Component} from "react";
import PropTypes from "prop-types";
import {Select} from "antd";
import {buildCategoryTreeForDropDown} from "./tree";

export default class SelectCategoryTree extends Component {
  static defaultProps = {
    showAll: false,
    hideNone: false,
    allText: '-- ALL --',
    noneText: ' ',
  };
  static propTypes = {
    tree: PropTypes.object.isRequired,
    except: PropTypes.string,
    showAll: PropTypes.bool,
    hideNone: PropTypes.bool,
    allText: PropTypes.string,
    noneText: PropTypes.string,
  };

  render() {
    const {tree, except, allText, noneText, showAll, hideNone, ...props} = this.props;
    const data = buildCategoryTreeForDropDown(tree, except);
    return (
      <Select {...props}>
        {!hideNone && <Select.Option key={null} value={null}>{noneText}</Select.Option>}
        {showAll && <Select.Option key="" value="">{allText}</Select.Option>}
        {data.map(({categoryId, name}) =>
          <Select.Option key={categoryId} value={categoryId}>{name}</Select.Option>
        )}
      </Select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Category/SelectCategoryTree.js